import { useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useClient from '../../api/hooks/useClients';
import { toIcons } from '../../consts/Paths';
import MainContext from '../../context/MainContext';
import useIsMobile from '../../hooks/useIsMobile';
import { Client } from '../../interfaces';
import '../../styles/Modals.css';
import { formatDateYYYMMGG } from '../../utils/reformatDate';
import CustomInput from '../inputs/CustomInput';
import useOffer from '../../api/hooks/useOffers';
import useCategory from '../../api/hooks/useCategory';
import DragAndDropImages from '../inputs/DragAndDropImages';
import ReactQuill from 'react-quill';
import useConditions from '../../api/hooks/useConditions';

const OfferCreateModal = (props: any) => {
    const { isMobile } = useIsMobile();
    const { refresh, client, user } = useContext(MainContext);

    // const { RESPONSES, RESULTS, CTAs } = useClient(token);

    const { RESPONSES, RESULTS, CTAs } = useOffer();
    const { RESPONSES: RESPONSEcatgeory, RESULTS: RESULTcatgeory, CTAs: CTAsCategory } = useCategory();
    const { RESPONSES: RESPONSEConditions, RESULTS: RESULTConditions, CTAs: CTAsConditions } = useConditions();

    // const [clientList, setClientList] = useState<Client[]>([]);
    // const [clientDefaultValue, setClientDefaultValue] = useState('');

    const [paymentRules, setPaymentRules] = useState<any>([]);
    const [returnRules, setReturnRules] = useState<any>([]);
    const [categories, setCategories] = useState<any>([]);
    const [conditions, setConditions] = useState<any>([]);

    // console.log(returnRules);

    const date = new Date();

    const dateOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    };

    const formattedDate = new Intl.DateTimeFormat('it-IT').format(date);

    useEffect(() => {
        CTAs.getPaymentRules();
        CTAs.getReturnRules();
        CTAsCategory.getCategory();
        CTAsConditions.getConditions();
    }, [refresh]);

    useEffect(() => {
        /* console.log(RESPONSES.getListAllResponse, RESULTS.getListAllResult); */

        if (RESPONSES.returnRulesResponse?.ok) {
            setReturnRules([
                {
                    name: 'Seleziona',
                },
                ...RESULTS.returnRulesResult.map((item: any) => ({
                    id: Number(item.id),
                    name: item.name,
                })),
            ]);
        }

        if (RESPONSEcatgeory.getCategoriesResponse?.ok) {
            setCategories([
                {
                    name: 'Seleziona',
                },
                ...RESULTcatgeory.getCategoriesResult.map((item: any) => ({
                    id: Number(item.id),
                    name: item.name,
                })),
            ]);
        }

        if (RESPONSEConditions.getConditionsResponse?.ok) {
            setConditions([
                {
                    name: 'Seleziona',
                },
                ...RESULTConditions.getConditionsResult.map((item: any) => ({
                    id: Number(item.id),
                    name: item.name,
                })),
            ]);
        }
    }, [RESPONSES.returnRulesResponse, RESPONSEcatgeory.getCategoriesResponse, RESPONSEConditions.getConditionsResponse]);

    useEffect(() => {
        if (RESPONSES.paymentRulesResponse?.ok) {
            setPaymentRules([
                {
                    name: 'Seleziona',
                },
                ...RESULTS.paymentRulesResult.map((item: any) => ({
                    id: Number(item.id),
                    name: item.name,
                })),
            ]);
        }
    }, [RESPONSES.paymentRulesResponse]);

    // useEffect(() => {
    //     /*
    // console.log("client:", props?.client,clientDefaultValue);
    // console.log("offer:", props?.offer,clientDefaultValue); */
    //     const value = props.onEdit ? props.offer.client_id : client ? client.id : '';
    //     setClientDefaultValue(value);
    // });

    useEffect(() => {
        if (props.onEdit) {
            props.reset(props.offer);
        }
    }, [client]);

    useEffect(() => {
        if (!props.onEdit && props.client) {
            props.setValue('client', props.client.name);
        }
    }, []);

    const handleDescriptionChange = (value: string) => {
        props.setValue('long_description', value);
    };

    useEffect(() => {
        if (RESPONSES.createProductResponse) {
            console.log('crea prodotto', RESPONSES.createProductResponse);
            // navigate()
        }
    }, [RESPONSES.createProductResponse, RESULTS.createProductResult]);

    return (
        <div
            className='modal-wrapper'
            style={{
                height: `100vh`,
            }}
        >
            <div
                className={`offer-create-modal scroll-y  ${isMobile && 'general-modal-dimension-Mob'}`}
                style={{
                    width: isMobile ? 'calc(345px - 64px)' : '' /* 
          height: "75vh", */,
                    padding: isMobile ? '25px 19px 0 21px' : '',
                }}
            >
                <div className='offer-create-modal-content' style={{ margin: isMobile ? '0' : '' }}>
                    <div className='modal-header'>
                        <p className='modal-title'>{props.onEdit ? 'Edit offer' : 'New offer'}</p>
                        <div className='Oval' onClick={props.toggler.toggle}>
                            <img src={`${toIcons}/close.svg`} />
                        </div>
                    </div>
                    <div
                        style={{
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? '20px' : '',
                            marginTop: isMobile ? '33px' : '',
                        }}
                    >
                        <CustomInput
                            title={'Nome prodotto'}
                            name={'title'}
                            width='100%'
                            type='text'
                            register={props.register}
                            errors={props.errors}
                            defaultValue={props.onEdit ? props.offer.name : ''}
                            constraints={{
                                required: true,
                            }}
                        />
                        {/* <CustomInput
                            title={'GTIN (EAN, ISBN)'}
                            name={'gtin'}
                            width={isMobile ? '100%' : 234}
                            type='text'
                            register={props.register}
                            errors={props.errors}
                            defaultValue={props.onEdit ? props.offer.name : ''}
                            constraints={{
                                required: true,
                            }}
                        /> */}
                    </div>
                    <div
                        className='offer-create-modal-date-location-inputs-box'
                        style={{
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? '20px' : '',
                        }}
                    >
                        <CustomInput
                            title={'Condizione'}
                            name={'condition_id'}
                            width={isMobile ? '100%' : 264}
                            type='select'
                            options={conditions}
                            register={props.register}
                            errors={props.errors}
                            defaultValue={0}
                            idValue={true}
                            constraints={{
                                required: true,
                            }}
                        />
                        <CustomInput
                            title={'Categoria'}
                            name={'category_id'}
                            width={isMobile ? '100%' : 264}
                            type='select'
                            options={categories}
                            register={props.register}
                            errors={props.errors}
                            idValue={true}
                            constraints={{
                                required: true,
                                validate: (e: any) => {
                                    if (e === 'Seleziona') {
                                        return false;
                                    } else {
                                        return true;
                                    }
                                },
                            }}
                        />
                    </div>
                    <div
                        className='offer-create-modal-date-location-inputs-box'
                        style={{
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? '20px' : '',
                        }}
                    >
                        {/* <CustomInput
                            width={isMobile ? '100%' : 234}
                            title={'Date'}
                            name={'issue_date'}
                            type='Date'
                            register={props.register}
                            errors={props.errors}
                            defaultValue={props.onEdit ? formatDateYYYMMGG(new Date(props.offer.issue_date)) : new Date()}
                        /> */}
                        <CustomInput
                            width={isMobile ? '100%' : 234}
                            title={'Prezzo di vendita'}
                            name={'final_price'}
                            type='text'
                            register={props.register}
                            errors={props.errors}
                            defaultValue={props.onEdit ? props.offer.location : ''}
                        />
                        <CustomInput
                            width={isMobile ? '100%' : 264}
                            title={'Pagamento'}
                            name={'payment_rule_id'}
                            type='select'
                            options={paymentRules}
                            register={props.register}
                            idValue={true}
                            errors={props.errors}
                            constraints={{
                                required: true,
                                validate: (e: any) => {
                                    if (e === 'Seleziona') {
                                        return false;
                                    } else {
                                        return true;
                                    }
                                },
                            }}
                        />
                    </div>
                    <div
                        className='offer-create-modal-date-location-inputs-box'
                        style={{
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? '20px' : '',
                        }}
                    >
                        <CustomInput width={isMobile ? '100%' : 234} title={'Quantità'} name={'quantity'} type='text' register={props.register} errors={props.errors} defaultValue={''} />
                        <CustomInput
                            width={isMobile ? '100%' : 234}
                            title={'Peso'}
                            name={'waist'}
                            type='text'
                            register={props.register}
                            errors={props.errors}
                            defaultValue={props.onEdit ? props.offer.location : ''}
                        />
                        {/* <CustomInput title={'Data pubblicazione '} name={'publish_date'} type='text' register={props.register} errors={props.errors} defaultValue={String(formattedDate)} /> */}
                    </div>
                    <div
                        style={{
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? '20px' : '',
                        }}
                    >
                        <CustomInput
                            width='100%'
                            title={'Politica di reso'}
                            name={'return_rule_id'}
                            type='select'
                            options={returnRules}
                            register={props.register}
                            errors={props.errors}
                            idValue={true}
                            constraints={{
                                required: true,
                                validate: (e: any) => {
                                    if (e === 'Seleziona') {
                                        return false;
                                    } else {
                                        return true;
                                    }
                                },
                            }}
                        />
                    </div>
                    <div
                        style={{
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? '20px' : '',
                            marginTop: isMobile ? '33px' : '33px',
                        }}
                    >
                        {/* <CustomInput
                            title={'Descrizione'}
                            name={'long_description'}
                            width='100%'
                            height={100}
                            type='textarea'
                            register={props.register}
                            errors={props.errors}
                            defaultValue={props.onEdit ? props.offer.name : ''}
                            constraints={{
                                required: true,
                            }}
                        /> */}
                        <ReactQuill
                            style={{ marginBottom: 50, marginTop: 10 }}
                            theme='snow'
                            onChange={handleDescriptionChange}
                            modules={{
                                toolbar: [
                                    [{ font: [] }],
                                    [{ size: [] }],
                                    [{ align: [] }],
                                    [{ color: [] }],
                                    [{ list: 'ordered' }, { list: 'bullet' }],
                                    ['bold', 'italic', 'underline', 'strike'],
                                    ['clean'],
                                ],
                            }}
                        />
                        <DragAndDropImages setValue={props.setValue} isEdit={false} />
                        <div style={{ display: 'none' }}>
                            <CustomInput title={'userId'} name={'user_id'} width='100%' height={100} type='text' register={props.register} errors={props.errors} defaultValue={user?.id} />
                        </div>
                    </div>
                </div>
                <button className='modal-button' type='submit' disabled={props.readOnly} style={{ width: isMobile ? '80%' : '' }}>
                    <p className='modal-button-text'>{props.onEdit ? 'Save' : 'Create Offer'}</p>
                </button>
            </div>
        </div>
    );
};
export default OfferCreateModal;
